import React from "react";
import { FiCheckCircle, FiEdit3, FiPhone, FiShield } from "react-icons/fi";

export const APPLY_LOAN_STEPS = [
  { id: 1, title: "Mobile Verify", subtitle: "OTP check" },
  { id: 2, title: "PAN & Aadhaar", subtitle: "Identity check" },
  { id: 3, title: "Loan Details", subtitle: "Income, address & submit" },
];

const STEP_COPY = {
  1: { headline: "Verify mobile", sub: "Step 1 of 3" },
  2: { headline: "Verify identity", sub: "Step 2 of 3" },
  3: { headline: "Loan details", sub: "Step 3 of 3" },
};

const STEP_ICONS = {
  1: FiPhone,
  2: FiShield,
  3: FiEdit3,
};

const ApplyLoanSidebar = ({ currentStep, skipMobileOtp = false }) => {
  const steps = skipMobileOtp
    ? APPLY_LOAN_STEPS.map((step) =>
        step.id === 1
          ? { ...step, title: "Mobile", subtitle: "Mobile number" }
          : step
      )
    : APPLY_LOAN_STEPS;
  const copy =
    skipMobileOtp && currentStep === 1
      ? { headline: "Enter mobile", sub: "Step 1 of 3" }
      : STEP_COPY[currentStep] || STEP_COPY[1];
  const totalSteps = steps.length;
  const completedSteps = Math.max(0, currentStep - 1);
  const progressValue = Math.round((completedSteps / totalSteps) * 100);

  return (
    <div className="apply-now1-sidepanel">
      <div className="apply-now1-sidepanel__card">
        <div className="apply-now1-sidepanel__head">
          <div className="apply-now1-sidepanel__stepchip" aria-hidden="true">
            {currentStep}/{totalSteps}
          </div>
          <div className="apply-now1-sidepanel__copy">
            <span className="apply-now1-sidepanel__eyebrow">Application Journey</span>
            <h1>{copy.headline}</h1>
            <p>{copy.sub}</p>
          </div>
        </div>

        <div className="apply-now1-sidepanel__progress">
          <div className="apply-now1-sidepanel__progress-meta">
            <span>Progress</span>
            <strong>{progressValue}%</strong>
          </div>
          <div className="apply-now1-sidepanel__progress-bar">
            <span style={{ width: `${progressValue}%` }} />
          </div>
        </div>
      </div>

      <nav className="apply-now1-sidepanel__track" aria-label="Progress">
        {steps.map((step) => {
          const done = currentStep > step.id;
          const active = currentStep === step.id;
          const Icon = STEP_ICONS[step.id];
          return (
            <div
              key={step.id}
              className={`apply-now1-sidepanel__item ${active ? "is-active" : ""} ${done ? "is-done" : ""}`}
            >
              <div className="apply-now1-sidepanel__text">
                <em>0{step.id}</em>
                <strong>{step.title}</strong>
                <small>{step.subtitle}</small>
              </div>
              <span className="apply-now1-sidepanel__icon">
                {done ? <FiCheckCircle /> : <Icon />}
              </span>
            </div>
          );
        })}
      </nav>
    </div>
  );
};

export default ApplyLoanSidebar;
